import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SORTING_ORDER, SortingDirectionValues } from 'models/Sort';

const useMultiSort = (
  tableColumns: string[],
  sortingValues: Partial<Record<string, string>>,
  labelTranslations: Partial<Record<string, string>>,
  directionCopy: Record<string, SortingDirectionValues[string]> = {},
) => {
  const { t } = useTranslation();

  const sortColumns = useMemo(
    () => tableColumns.filter((column) => !!sortingValues[column]),
    [tableColumns, sortingValues],
  );

  const multiSortValues = useMemo(
    () =>
      sortColumns.map((column) => ({
        value: sortingValues[column],
        label: t(labelTranslations[column]),
      })),
    [sortColumns, sortingValues, labelTranslations, t],
  );

  const multiSortDirectionTranslation = useMemo(() => {
    const result: SortingDirectionValues = {};

    for (const column of sortColumns) {
      const sort = sortingValues[column];
      const value = directionCopy[sort];

      result[sort] = {
        [SORTING_ORDER.A_TO_Z]: t(value?.[SORTING_ORDER.A_TO_Z] || 'aToZ'),
        [SORTING_ORDER.Z_TO_A]: t(value?.[SORTING_ORDER.Z_TO_A] || 'zToA'),
      };
    }

    return result;
  }, [sortColumns, sortingValues, directionCopy, t]);

  return { multiSortValues, multiSortDirectionTranslation };
};

export default useMultiSort;
